import { AccessLevel } from 'core/utils';

const isAdmin = () => {
	const access_level = window?.cj?.user?.access_level;
	if (access_level === AccessLevel.CRATEJOY_ADMIN) return true;
	return false;
};

export default isAdmin;
